import { render, staticRenderFns } from "./RelatPedidos.vue?vue&type=template&id=0afae07c&"
import script from "./RelatPedidos.vue?vue&type=script&lang=js&"
export * from "./RelatPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports